





























































































import { Component, Vue } from 'vue-property-decorator'
import { RedCapital, SelectedCountry, TitleTemplatePublic } from '@/configuration'
import Minimoainvertir from '@/views/howitworks/Minimoainvertir.vue'

@Component({
	metaInfo: {
		title: 'Perfil de inversión',
		titleTemplate: TitleTemplatePublic,
		htmlAttrs: {
		// @ts-ignore
		lang: RedCapital[SelectedCountry].Lang,
		}
	},
	components: {
		Minimoainvertir
	}
})

export default class GoodToKnow extends Vue {}
